import axios from 'axios';

const BASE_URL = String(process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

function client(token) {
  return axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    timeout: 70000,
  });
}

/**
 * Sends the question + tap behavior to the orb and returns its prophecy:
 * { mood, desperationLevel, sentiment, category, response, rowId }
 */
export async function askOrb({ token, question, tapCount, tapDurationMs, tapIntervalsMs, userId, name, email }) {
  const { data } = await client(token).post('/askOrb', {
    question,
    tapCount,
    tapDurationMs,
    tapIntervalsMs,
    userId,
    name,
    email,
  });
  if (!data?.success) throw new Error(data?.message || 'The orb stayed silent.');
  return data;
}

/** Fire-and-forget: records that the prophecy card was downloaded or shared. */
export function reportShareEvent({ token, rowId, action, format }) {
  if (!rowId) return Promise.resolve();
  return client(token)
    .post('/orbShareEvent', { rowId, action, format })
    .catch(() => { /* analytics only — never block the player on this */ });
}
